import React from "react";
import { Accordion } from "react-bootstrap";

const CustomAccordion = ({
  eventKey,
  header,
  children,
}) => {
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>{header}</Accordion.Header>
      <Accordion.Body>{children}</Accordion.Body>
    </Accordion.Item>
  );
};

export default CustomAccordion;
